import React from "react";
import { Route, Switch } from "react-router-dom";
import Home from "./containers/Home";
import NotFound from "./containers/NotFound";
import Login from "./containers/Login";
import Signup from "./containers/Signup";
import LoginDetail from "./containers/LoginDetail";
import Settings from "./containers/Settings";
import AuthenticatedRoute from "./components/AuthenticatedRoute";
import UnauthenticatedRoute from "./components/UnauthenticatedRoute";
import NewLoginDetail from "./containers/NewLoginDetail";
import ForgotPassword from "./containers/ForgotPassword";
import PasswordChange from "./containers/PasswordChange";
import PasswordGeneratorPage from "./containers/PasswordGeneratorPage";
import ImportExport from "./containers/ImportExport";
import Profile from "./containers/Profile";

export default function Routes({ appProps }) {
    return (
      <Switch>
        <AuthenticatedRoute path="/" exact component={Home} appProps={appProps} />
        <UnauthenticatedRoute path="/login" exact component={Login} appProps={appProps} />
        <UnauthenticatedRoute path="/signup" exact component={Signup} appProps={appProps} />
        <UnauthenticatedRoute path="/forgotPassword" exact component={ForgotPassword} appProps={appProps} />
        <AuthenticatedRoute path="/settings" exact component={Settings} appProps={appProps} />
        <AuthenticatedRoute path="/profile" exact component={Profile} appProps={appProps} />
        <AuthenticatedRoute path="/changepassword" exact component={PasswordChange} appProps={appProps} />
        <AuthenticatedRoute path="/password-generator" exact component={PasswordGeneratorPage} appProps={appProps} />
        <AuthenticatedRoute path="/import-export" exact component={ImportExport} appProps={appProps} />
        <AuthenticatedRoute path="/logindetails/new" exact component={NewLoginDetail} appProps={appProps} />
        <AuthenticatedRoute path="/logindetails/:id" exact component={LoginDetail} appProps={appProps} />
        { /* Finally, catch all unmatched routes */ }
        <Route component={NotFound} />
      </Switch>
    );
  }